import { Button, Container, SearchInput } from '@/components';
import {
  ModalProvider,
  useModal,
} from '@/components/common/modal/ModalContext';
import React, { useEffect } from 'react';
import AccountForm from './AccountForm';
import { IoMdAdd } from 'react-icons/io';
import AccountFormTable from './AccountFormTable';
import { useAccountForm } from '@/context/accountFormContext/AccountFormContextProvider';

const NewAccountFormView = () => {
  const { openModal, closeModal } = useModal();
  const {
    clearFormData,
    searchQuery,
    setSearchQuery,
    getAccountFormAPI,
    setCurrentPage,
  } = useAccountForm();
  const handleOpenModal = () => {
    clearFormData();
    openModal(
      <AccountForm closeModal={closeModal} />,
      'Create Debtor Account Form',
    );
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    setCurrentPage(0);
    const debounceTimeout = setTimeout(() => {
      getAccountFormAPI();
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [searchQuery]);

  return (
    <Container title={'NEW DEBTOR ACCOUNT CREATION FORM'}>
      <div className="flex justify-end gap-5 m-5">
        <SearchInput
          placeholder="Search Account Form..."
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <div className="lg:mt-0 flex justify-center mt-2">
          <Button className="flex items-center" onClick={handleOpenModal}>
            <IoMdAdd className="mr-2" />
            Create New Account
          </Button>
        </div>
      </div>
      <AccountFormTable />
    </Container>
  );
};
const App = () => (
  <ModalProvider>
    <NewAccountFormView />
  </ModalProvider>
);

export default App;
